import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { FxJourneyCompletionPage, FxMultiButtons } from 'axp-fx-common';
import labels from '../../../constants/labels';
import useAutoLogout from '../../../hooks/useAutoLogout';

/**
 * Shared completion page for the registration flow, with a single
 * "Login to FileXpress" CTA. Because enrollment completed under the sign-up
 * session, the CTA first logs the user out; identity then lands the user on the
 * FileXpress app (DestPage=appBaseUrl) via its iframe. The same logout also
 * happens silently after 10 seconds (see useAutoLogout).
 * An explicit `icon` overrides the status-derived icon on FxJourneyCompletionPage.
 */
const RegistrationResultPage = ({ status, icon, heading, details }) => {
  const appBaseUrl = useSelector((state) => state.getIn(['config', 'appBaseUrl']));
  const intranetIdentityBaseUrl = useSelector((state) => state.getIn(['config', 'intranetIdentityBaseUrl']));

  const logoutUrl = `${intranetIdentityBaseUrl}/logout?DestPage=${encodeURIComponent(appBaseUrl)}`;

  useAutoLogout(logoutUrl);

  const actions = (
    <FxMultiButtons
      primaryButtonLabel={labels.LOGIN_TO_FX}
      onPrimaryButtonClick={() => window.location.assign(logoutUrl)}
      justifyButtons="center"
    />
  );

  return (
    <FxJourneyCompletionPage
      status={status}
      icon={icon}
      heading={heading}
      details={details}
      actions={actions}
    />
  );
};

RegistrationResultPage.propTypes = {
  status: PropTypes.oneOf(['success', 'failed', 'partial']).isRequired,
  icon: PropTypes.node,
  heading: PropTypes.string.isRequired,
  details: PropTypes.string.isRequired,
};

RegistrationResultPage.defaultProps = {
  icon: null,
};

export default RegistrationResultPage;
